import React, { FunctionComponent, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { SecureTextInputProps } from "./ISecureTextInputProps";
import SecureTextInput from "./SecureTextInput";

interface ISecureTextInputFieldCProps extends SecureTextInputProps {
    name: string;
    inputRef?: React.Ref<HTMLInputElement>;
}

const SecureTextInputFieldC: FunctionComponent<ISecureTextInputFieldCProps> = (props) => {
    const [focus, setFocus] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const { label, placeholder, type, name, inputRef, multiline, rows, emojiErrorMessage, showEmojiWarning, blockEmojis, ...rest } = props as any;
    const {
        control,
        formState: { errors },
    } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <SecureTextInput
                    {...field}
                    {...rest}
                    inputRef={inputRef}
                    label={label}
                    placeholder={placeholder}
                    type={show ? "text" : type}
                    error={!!errors[name]}
                    multiline={multiline}
                    rows={rows}
                    emojiErrorMessage={emojiErrorMessage}
                    showEmojiWarning={showEmojiWarning}
                    blockEmojis={blockEmojis}
                    helperText={errors[name] ? String(errors[name]?.message) : ""}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    shrink={!!field.value || focus}
                />
            )}
        />
    );
};

export default SecureTextInputFieldC;
